import styled from "styled-components";

export const PlayerIconSelectorContainer = styled.fieldset`
  margin: 0;
  min-width: 0;
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: var(--space-3) var(--space-4);
  padding: var(--space-3) var(--space-4) var(--space-4);
  background: var(--card-sunken);
  border: var(--border-w) solid var(--line);
  border-radius: var(--radius-lg);

  legend {
    padding: 0 var(--space-1);
    font-size: var(--text-sm);
    font-weight: 700;
    color: var(--ink-soft);
  }
`;

export const AvatarButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-1);
  padding: var(--space-2);
  background: var(--card);
  border: var(--border-w) solid var(--ink);
  border-radius: var(--radius-lg);
  box-shadow: 0 var(--lip) 0 var(--line-strong);
  color: var(--ink);
  font-family: var(--font-display);
  font-weight: 600;
  font-size: var(--text-sm);
  text-transform: capitalize;
  cursor: pointer;
  transition: transform var(--dur-fast) var(--ease-out), box-shadow var(--dur-fast) var(--ease-out);

  @media (hover: hover) {
    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 calc(var(--lip) + 1px) 0 var(--line-strong);
    }
  }

  &:active {
    transform: translateY(var(--lip));
    box-shadow: 0 0 0 var(--line-strong);
  }
`;

export const Swatches = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
`;

export const Swatch = styled.button<{ $color: string; $selected?: boolean }>`
  width: 32px;
  height: 32px;
  padding: 0;
  border-radius: var(--radius-full);
  background: ${({ $color }) => $color};
  border: var(--border-w) solid var(--ink);
  box-shadow: ${({ $selected }) =>
    $selected ? "0 0 0 3px var(--card), 0 0 0 5px var(--ink)" : "0 3px 0 var(--ink)"};
  color: white;
  display: grid;
  place-items: center;
  cursor: pointer;
  transition: transform var(--dur-fast) var(--ease-bounce);
  transform: ${({ $selected }) => ($selected ? "scale(1.08)" : "none")};

  &:active {
    transform: scale(0.92);
  }
`;

export const AnimalGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(52px, 1fr));
  gap: var(--space-1);
  padding: var(--space-2) var(--space-3) var(--space-3);
  max-width: min(420px, 90vw);
  max-height: 50vh;
  overflow-y: auto;
`;

export const AnimalOption = styled.button<{ $selected?: boolean }>`
  display: grid;
  place-items: center;
  padding: var(--space-1);
  aspect-ratio: 1;
  border-radius: var(--radius-md);
  border: var(--border-w) solid ${({ $selected }) => ($selected ? "var(--teal)" : "transparent")};
  background: ${({ $selected }) => ($selected ? "var(--teal-tint)" : "transparent")};
  cursor: pointer;
  transition: transform var(--dur-fast) var(--ease-bounce), background var(--dur-fast);

  &:hover {
    background: var(--card-sunken);
    transform: scale(1.08);
  }
`;

export const SearchBox = styled.div`
  padding: var(--space-2) var(--space-3) 0;
`;
